/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import React from 'react';
import { Dropdown, Menu } from 'antd';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { isLoginSelector, userInfoSelector } from 'src/modules/Auth/Auth.selector';
import Favorited from 'src/modules/Accounts/component/Favorited';
import { LogoutIcon } from '@heroicons/react/outline';
import { ReactComponent as IconWallet } from 'src/assets/svg/ic-wallet.svg';
import { ReactComponent as IconAccount } from 'src/assets/svg/ic-account.svg';
import { ReactComponent as IconNFTCollection } from 'src/assets/svg/ic-nft-collection.svg';
import { ReactComponent as IconOtherNetwork } from 'src/assets/svg/other_networks.svg';
import { ReactComponent as HeartIcon } from 'src/assets/svg/heart-account.svg';
import MyWallet from 'src/modules/Accounts/component/MyWallet';
import Account from 'src/modules/Accounts/component/Account';
import NFTClub from 'src/modules/Accounts/component/NFTClub';
import NFTWatchList from 'src/modules/NftTracking/WatchList';
import OtherNetwork from 'src/modules/Accounts/component/OtherNetwork';
import withLogin from 'src/hoc/login.enhance';
import { NavLink, useHistory } from 'react-router-dom';

const Button = styled.button`
    :disabled {
        opacity: 0.5;
        &:hover {
            cursor: pointer;
            transform: scale(1);
        }
    }
    .logo {
        margin-left: 16px;
        width: 24px;
        height: 24px;
        justify-content: center;
    }
    .icon-arrow {
        margin-left: 10px;
    }
`;

interface IBTNProps {
    className?: string;
    item?: any;
    history: any;
}

const menuAccount = [
    { key: 'wallet', icon: <IconWallet />, label: 'My Wallet', component: <MyWallet /> },
    { key: 'profile', icon: <IconAccount />, label: 'Profile', component: <Account /> },
    { key: 'nft-club', icon: <IconNFTCollection />, label: 'NFT Club', component: <NFTClub /> },
    {
        key: 'nft-analytics/watch-list/view',
        icon: <IconNFTCollection />,
        label: 'NFT Watch List',
        component: <NFTWatchList />,
    },
    { key: 'ido-joined', icon: <IconOtherNetwork />, label: 'IDO Joined', component: <OtherNetwork /> },
    {
        key: 'favorites',
        icon: <HeartIcon style={{ marginLeft: 5 }} />,
        label: 'Favorited',
        component: <Favorited />,
    },
    {
        key: 'logout',
        icon: (
            <div className="items-center" style={{ width: 32, height: 32 }}>
                <LogoutIcon width={28} height={24} />
            </div>
        ),
        label: 'Logout',
        component: undefined,
    },
];

const BTNAccount = (props: IBTNProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => {
    const { className, history, item, ...rest } = props;
    return (
        <Button
            className={`btn-primary ${className}`}
            onClick={() => {
                history.push('/accounts?tab=profile');
            }}
            {...rest}
        >
            {item?.email.charAt(0)}
        </Button>
    );
};
const MenuContainer = styled(Menu)`
    border-radius: 16px;
    width: 180px;
    background: #141416 !important;
    .logo {
        margin-right: 16px;
        width: 24px;
        height: 24px;
        justify-content: center;
    }
`;

const DropDownAccount = React.memo(({ onLogout }: { onLogout: () => void } & any) => {
    const isLogin = useSelector(isLoginSelector);
    const userInfo = useSelector(userInfoSelector);
    const history = useHistory();
    // const params = new URLSearchParams(window.location.search);
    // const tabUrl = params.get('tab');
    // const [active, setActive] = useState(tabUrl || 'wallet');

    // const onMenuClick = (key: string) => {
    //     setActive(key);
    //     if (
    //         key === 'profile' ||
    //         key === 'wallet' ||
    //         key === 'nft-club' ||
    //         key === 'favorites' ||
    //         key === 'other-networks'
    //     ) {
    //         history.push(`/accounts?tab=${key}`);
    //     } else {
    //         history.push('/nft-analytics/watch-list/view');
    //     }
    // };

    const menus = () => (
        <MenuContainer theme="dark" mode="horizontal">
            {menuAccount.map((item: any) => {
                if (item.key === 'logout') {
                    return isLogin ? (
                        <Menu.Item key={item.key} icon={item.icon} onClick={onLogout}>
                            {item.label}
                        </Menu.Item>
                    ) : null;
                }
                return (
                    <Menu.Item
                        key={item.key}
                        style={{
                            borderBottomWidth: '1px',
                            borderBottomStyle: 'solid',
                            borderBottomColor: '#353945',
                        }}
                        icon={item.icon}
                    >
                        <NavLink
                            style={{
                                fontSize: 14,
                            }}
                            to={`/accounts?tab=${item.key}`}
                        >
                            {item.label}
                        </NavLink>
                    </Menu.Item>
                );
            })}
        </MenuContainer>
    );

    return (
        <Dropdown overlay={menus} placement="bottomRight">
            <BTNAccount className="btn-account" history={history} item={userInfo.auth} />
        </Dropdown>
    );
});

export default withLogin(DropDownAccount);
